import { DataLifeCyclePeriod } from '../../constants'
import { ObjectHistory, HistoryStore } from '../../model/constructs'

export const initializeObjectHistory = (objectHistory?: ObjectHistory) => {
  if (objectHistory && !objectHistory?.recentStateHistory) {
    objectHistory.recentStateHistory = new HistoryStore(ObjectHistory.getDefaultHistoryObjectParams(DataLifeCyclePeriod.DEVICE_PERIOD))
  }
  if (objectHistory && !objectHistory?.dailyStateHistory) {
    objectHistory.dailyStateHistory = new HistoryStore(ObjectHistory.getDefaultHistoryObjectParams(DataLifeCyclePeriod.DAILY))
  }
  if (objectHistory && !objectHistory?.weeklyStateHistory) {
    objectHistory.weeklyStateHistory = new HistoryStore(ObjectHistory.getDefaultHistoryObjectParams(DataLifeCyclePeriod.WEEKLY))
  }

  if (objectHistory && !objectHistory?.monthlyStateHistory) {
    objectHistory.monthlyStateHistory = new HistoryStore(ObjectHistory.getDefaultHistoryObjectParams(DataLifeCyclePeriod.MONTHLY))
  }

  if (objectHistory && !objectHistory?.yearlyStateHistory) {
    objectHistory.yearlyStateHistory = new HistoryStore(ObjectHistory.getDefaultHistoryObjectParams(DataLifeCyclePeriod.YEARLY))
  }
}
